import { Heading } from '@chakra-ui/react'
import React from 'react'
import map from 'lodash/map'

const Title = ({
  text,
  color = 'custom.primary',
  align,
  size,
  styles = [],
  isPreview,
  isEditing,
}) => {
  const arrStyles = map(styles)
  return (
    <Heading
      textAlign={align || 'center'}
      color={color}
      size={size || 'md'}
      my={isEditing && 4}
      opacity={!text && 0.5}
      fontWeight={arrStyles.includes('bold') ? 'bold' : 'normal'}
      fontStyle={arrStyles.includes('italic') ? 'italic' : 'normal'}
      textDecoration={arrStyles.includes('underline') ? 'underline' : 'none'}
    >
      {text || ((isPreview || isEditing) && '編輯標題文字')}
    </Heading>
  )
}

export default Title
